import React from "react";
import { Typography, Checkbox } from "@material-ui/core";
import { Check } from "components/MaterialSymbol/MaterialIcons";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
const useStyles = makeStyles(styles);

const SelectAllCheckbox = ({ checked, setChecked, setSelected, items = [] }) => {
    const classes = useStyles();

    return (
        <div
            style={{
                textAlign: "center",
                display: "flex",
                alignItems: "center",
            }}
        >
            <Typography className="table-select-all-label">Select All</Typography>
            <Checkbox
                tabIndex={-1}
                checked={checked}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if (checked) {
                        setSelected([]);
                    } else {
                        setSelected(items.map((o) => o.id));
                    }
                    setChecked(!checked);
                }}
                checkedIcon={<Check className={classes.checkedIcon} />}
                icon={<Check className={classes.uncheckedIcon} />}
                classes={{
                    checked: classes.checked,
                    root: classes.checkRoot,
                }}
            />
        </div>
    );
};

export default SelectAllCheckbox;
